import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';

import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, FormControl, FormControlLabel, FormLabel, Grid, Paper, RadioGroup, Radio, Snackbar, SnackbarContent, Typography} from '@mui/material';

import BusinessBeneficialOwnerDocumentCreateMutation from './BusinessBeneficialOwnerDocumentCreateMutation';
import BusinessIdentityDocumentCreateMutation from './BusinessIdentityDocumentCreateMutation';
import ConfirmationDialog from '../ui/ConfirmationDialog';
import PageTitle from '../ui/PageTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import classNames from 'classnames';
import AppBindStyles from '../../AppBindStyles';
import SavingSpinner from '../ui/SavingSpinner';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import AbEnvironment from '../auth/AbEnvironment';


import { green } from '@mui/material/colors';

const abEnvironment = new AbEnvironment();
const DocumentUploadQuery = graphql`
query DocumentUploadQuery($biId: UUID!) {
  businessIdentityTByBiId(biId: $biId) {   
    accountId
    businessName
    businessType
    accountTByAccountId {
      dwollaCid
    }
    beneficialOwnerTsByBiId {
      nodes {
        boId
				firstName
        lastName
        dwollaId
      }
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    },
    success: {
      backgroundColor: green[300],
    },
    error: {
      backgroundColor: theme.palette.error.light,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
    close: {
      padding: theme.spacing(0.5),
    },
    select: {
      marginLeft: -8,
      marginTop: -8,
    },
    dateField: {
      width: 160,
    },
    businessClassification: {
      margin: theme.spacing(1),
    },
    errorText: {
      color: "#f44336"
    }
    
});
  
class DocumentUpload extends Component {

    state = {
      showSpinner: false,
      saveStatus: null,
      saveMessage: null,
      snackbarOpen: false,
      confirmUpload: false,

      documentType: "0",
      fileName: null,
      base64File: null
    }

    goBack() {
      this.props.history.goBack();
    }
    
    showSpinner() {
        return this.state.showSpinner;
    }
 
    disableUpload() {
      if (this.state.base64File) {
        return false;
      }
      return true;
    }

    handleDocumentTypeChange(event) {
      this.setState({documentType: event.target.value})
    }

    handleChange(selectorFiles) {
        //console.log(selectorFiles);
        let reader = new FileReader();
        reader.readAsDataURL(selectorFiles[0]);
        const name = selectorFiles[0].name;
        
        //console.log(name);
        reader.onload = (e) => {
          //console.log('img data' , e.target.result);
          //console.log(selectorFiles[0].size);
          if (selectorFiles[0].size > 5000000) {
            this.setState({fileName: "", base64File: "", error: "File cannot be greater than 5 MG"})
          } else {
            this.setState({fileName: name, base64File: e.target.result, error: ''});
          }
      
          //this.postFile(name, e.target.result);

        }
    }

    postFile = (dwollaId, dwollaCId) => {
      const params = new URLSearchParams(this.props.location.search);
      let biId = params.get('biId');
      let boId = params.get('boId');
      let type = params.get('type');

      if (type === 'be') {
        this.postBusinessIdentityFile(biId, dwollaId, dwollaCId);
      } else if (type === 'bo') {
        this.postBeneficialOwnerFile(biId, boId, dwollaId, dwollaCId);
      }
    }

    postBusinessIdentityFile = (biId, dwollaId, dwollaCId) => {


      const { callPartnerApi } = this.props.auth;
   
      this.setState({showSpinner: true});
      let aPjwt = abEnvironment.getPjwt();
      let accountId = abEnvironment.getUserAttribute("a_id");
      
      //dwolla always wants other for business documents
      //even though we keep a lower level of granularity
      let documentType = 'other';
    
      // Call server side ach form prep
      let payload = {
        operation: "uploadDwollaDocument",
        params: {
          pJwt:       aPjwt,
          ownerId:    null,
          entityId:   dwollaId,
          type:       documentType,
          fileName:   this.state.fileName,
          file:       this.state.base64File
        }
      };
  
      callPartnerApi('appbind/generic',
                     'POST',
                     payload
      ).then(resp => {
        return resp.json();
      }).then(data => {


        if (data.err) {
          throw (data);          
        }

          BusinessIdentityDocumentCreateMutation.commit(biId, accountId, parseInt(this.state.documentType, 10), data.id)
      .then(response => {
        this.goBack();

      })
      

      }).catch(reason => {
        let error = 'Problem uploading document';
        //see if this is a duplicate (from using backbutton perhaps)
        if (reason.err && reason.err.body && reason.err.body.code && (reason.err.body.code === 'DuplicateResource')) {
          error = 'Cannot upload more than one document';
        }

        this.setState({ showSpinner: false, snackbarOpen: true, saveStatus: 'error', saveMessage: error });
     });      
    }

    postBeneficialOwnerFile = (biId, boId, dwollaId, dwollaCId) => {

      const { callPartnerApi } = this.props.auth;
   
      this.setState({showSpinner: true});
      let aPjwt = abEnvironment.getPjwt();
      let success = false;

      //convert document type to a dwolla equivalent
      let documentType = '';
      if (this.state.documentType === "0") {
        documentType = 'license';
      } else if (this.state.documentType === "1") {
        documentType = 'passport';
      } else if (this.state.documentType === "2") {
        documentType = 'idCard';
      } else if (this.state.documentType === "3") {
        documentType = 'other';
      }

      let payload = {
        operation: "uploadDwollaDocument",
        params: {
          pJwt:       aPjwt,
          ownerId:    dwollaId,
          entityId:   null,
          type:       documentType,
          fileName:   this.state.fileName,
          file:       this.state.base64File
        }
      };
  
      callPartnerApi('appbind/generic',
                     'POST',
                     payload
      ).then(resp => {
        if (resp.status === 200) {
          success = true;
        }
        return resp.json();
      }).then(data => {
        if (data.err) {
           throw (data);          
        }
        if (!success) {
          throw new Error("Error uploading document");
        }

        BusinessBeneficialOwnerDocumentCreateMutation.commit(boId, biId, parseInt(this.state.documentType, 10), data.id)
      .then(response => {
        this.goBack();
      })
      

      }).catch(reason => {
         //console.log('Failure uploading file: ' + JSON.stringify(reason));
         let error = 'Problem uploading document';
         //see if this is a duplicate (from using backbutton perhaps)
         if (reason.err && reason.err.body && reason.err.body.code && (reason.err.body.code === 'DuplicateResource')) {
           error = 'Cannot upload more than one document';
         }

         this.setState({ showSpinner: false, snackbarOpen: true, saveStatus: 'error', saveMessage: error });
      });      
    }

    handleSnackbarClose = (event, reason) => { 
      this.setState({ snackbarOpen: false, saveStatus: '', saveMessage: '' });
    }

    render() {
        const { isAuthenticated, isAuthenticatedReseller, needAssent, logError } = this.props.auth;
        const classes = this.props.classes;

        if (!isAuthenticated() || needAssent()) {
          return (
            <Redirect to='/home' />
          );
        } else if (isAuthenticatedReseller()) {

          const params = new URLSearchParams(this.props.location.search);
          let biId = params.get('biId');
          let boId = params.get('boId');
          let type = params.get('type');


          let backButtonText = 'Business Identity';
          if (boId) {
            backButtonText = 'Business Owner'
          }



          return (
            <QueryRenderer
              environment={abEnvironment.getEnvironment()}
              query={DocumentUploadQuery}
              variables={{biId: biId}}
              render={({error, props})=> {
                if (error) {
                  logError(error.message);
                  return (
                    <ServerError/>
                  );
                } else if (props) {

                  //find the right dwolla ID for the entity.  It could be on the account or on the beneficial owner.
                  let dwollaCId = props.businessIdentityTByBiId.accountTByAccountId.dwollaCid;
                  let dwollaId = props.businessIdentityTByBiId.accountTByAccountId.dwollaCid;
                  if (type === 'bo') {
                    //for business owners, the dwolla id is on the beneficial owner record...find it.
                    for (var i = 0; i < props.businessIdentityTByBiId.beneficialOwnerTsByBiId.nodes.length; i++) {
                      var bo = props.businessIdentityTByBiId.beneficialOwnerTsByBiId.nodes[i];
                      if (bo.boId === boId) {
                        //console.log('found dude: ' + bo.firstName + ' ' + bo.lastName + ' /' + bo.dwollaId);
                        dwollaId = bo.dwollaId;
                        break;
                      }
                    }
                  }

                  return (
                    <div id="document-upload" className={classes.root}>
                      <PageTitle title="Document upload" subtitle="Upload a required document." showBackButton={true} name={backButtonText} history={this.props.history}/>
        
                      <Paper className={classes.paper}>
                        <Grid container spacing={2} direction="row" justifyContent="flex-start">
        
                          <Grid item xs={12}>
                            {!boId &&
                              <FormControl component="fieldset">
                                <FormLabel component="legend">Document Type</FormLabel>
                                <RadioGroup aria-label="documentType" name="documentType" value={this.state.documentType} onChange={(e) => this.handleDocumentTypeChange(e)}>
                                  <FormControlLabel value="0" control={<Radio />} label="EIN letter" />
                                  {props.businessIdentityTByBiId.businessType === 'soleProprietorship' &&
                                  <React.Fragment>
                                  <FormControlLabel value="1" control={<Radio />} label="Fictitious Business Name Statement" />
                                  <FormControlLabel value="2" control={<Radio />} label="Certificate of Assumed Name" />
                                  <FormControlLabel value="3" control={<Radio />} label="Business License" />
                                  <FormControlLabel value="4" control={<Radio />} label="Sales/Use Tax License" />
                                  <FormControlLabel value="5" control={<Radio />} label="Registration of Trade Name" />
                                  <FormControlLabel value="6" control={<Radio />} label="Government-issued photo ID" />
                                  </React.Fragment>
                                  }
                                </RadioGroup>
                              </FormControl>
                            }
                            {boId &&
                              <FormControl component="fieldset">
                                <FormLabel component="legend">Document Type</FormLabel>
                                <RadioGroup aria-label="documentType" name="documentType" value={this.state.documentType} onChange={(e) => this.handleDocumentTypeChange(e)}>
                                  <FormControlLabel value="0" control={<Radio />} label="Drivers license" />
                                  <FormControlLabel value="1" control={<Radio />} label="Passport" />
                                  <FormControlLabel value="2" control={<Radio />} label="Other government issued id" />
                                </RadioGroup>
                              </FormControl>
                            }
                          </Grid>
        
                          <Grid item xs={12}>
                            <input type="file" multiple={false} onChange={ (e) => this.handleChange(e.target.files) } />
                          </Grid>
                          <Grid item xs={12}>
                            <div className={classes.errorText}>
                              <Typography variant="caption">{this.state.error}</Typography>
                            </div>
                          </Grid>

                          <Grid item xs={12}>
                            {!this.showSpinner() &&
                              <Button color="primary" variant="outlined" style={AppBindStyles.bottomButton}
                                disabled={this.disableUpload()}
                                onClick={() => {this.setState({confirmUpload: true})}}>
                                Send to ACH Partner
                              </Button> 
                            }
        
                            {this.showSpinner() &&
                            <Button color="primary" variant="outlined" style={AppBindStyles.bottomButton}>
                              <SavingSpinner/>
                            </Button>
                            }
                              <Snackbar
                                anchorOrigin={{
                                  vertical: 'bottom',
                                  horizontal: 'center',
                                }}
                                open={this.state.snackbarOpen}
                                onClose={this.handleSnackbarClose}
                              >
                                <SnackbarContent
                                  className={classNames(classes.message, classes[this.state.saveStatus])}
                                  onClose={this.handleSnackbarClose}
                                  message={
                                    <Typography variant="body1">
                                        {this.state.saveMessage}
                                    </Typography>
                                  }
                                  action={[
                                    <IconButton
                                      key="close"
                                      aria-label="Close"
                                      color="inherit"
                                      className={classes.close}
                                      onClick={this.handleSnackbarClose}
                                      size="large">
                                    <CloseIcon />
                                  </IconButton>
                                ]}
                              />
                            </Snackbar>
        
                          </Grid>
        
                        </Grid>
                        <ConfirmationDialog
                            open={this.state.confirmUpload}
                            onClose={() => { this.setState({confirmUpload:false});}}
                            onConfirm={() => {this.postFile(dwollaId, dwollaCId)}}
                            onCancel={() => { }}
                            title="Confirm information"
                            cancelBtn="Cancel"
                            okBtn="Ok"
                            irreversibleAction={true}
                          >
                            Please confirm you are uploading the correct type of document.  You will only be able to upload again if document is rejected.  Is information complete?
                        </ConfirmationDialog>
                      </Paper>
        
                    </div>
                  );
                }
                return <div><LoadingSpinner/></div>
              }}
            />
          );
        
        } else {
          return (
            <Redirect to='/home' />
          );
        }
      }

}

DocumentUpload.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(DocumentUpload);